'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module2App3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app3
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App3, _Component);

  function Module2App3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App3.__proto__ || (0, _getPrototypeOf2.default)(Module2App3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 3,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Eating HELPS guide'
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module2App3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Follow these helpful steps to encourage healthy eating habits for children.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'HELPS'
          ),
          _react2.default.createElement(
            ReactBootstrap.Accordion,
            null,
            _react2.default.createElement(
              ReactBootstrap.Panel,
              { header: 'Hungry', eventKey: '1' },
              'It helps if children learn to recognise and listen to their feelings of hunger. This will help them to eat when they feel hungry and not when food is available. Parents don\u2019t need to pressure children to eat when they\u2019re not hungry.'
            ),
            _react2.default.createElement(
              ReactBootstrap.Panel,
              { header: 'Eating', eventKey: '2' },
              'While children are eating it helps if they do not focus on other activities. Families often eat food while watching television. However, if we are distracted, we pay less attention to the food we are eating and our body\u2019s signals that we are full. This may mean we eat too much, or too little.'
            ),
            _react2.default.createElement(
              ReactBootstrap.Panel,
              { header: 'Location', eventKey: '3' },
              'It helps if children eat in locations that are specifically designed for eating and for food. Avoid eating in the lounge room, bedroom or car.'
            ),
            _react2.default.createElement(
              ReactBootstrap.Panel,
              { header: 'Plate', eventKey: '4' },
              'It helps if children eat from a plate, rather than straight from the fridge or the packaging. Using a plate or a bowl means that you can control how much your child eats and prevent them from overeating. This will also help children to learn about the amount of food they should be eating.'
            ),
            _react2.default.createElement(
              ReactBootstrap.Panel,
              { header: 'Sitting', eventKey: '5' },
              'It helps if children eat while sitting, rather than when standing, walking, or lying down.'
            )
          ),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
        )
      );
    }
  }]);
  return Module2App3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module2App3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App3.js
// module id = 1183
// module chunks = 0